import React, { useEffect } from 'react';
import { FormattedDate } from 'react-intl';
import { useTranslation } from 'react-i18next';

import "./QuickStatsTemplate.scss";

import { roundUp } from "utils/helpers";

const QuickStatsTemplate = ({ quickInfo, closeQuickInfo }) => {
  const { t } = useTranslation();

  useEffect(() => {

    const checkElement = (event) => {
      const currentElement = event.target;
      const nessery = document.querySelector(".quick-stats-template");

      if (!nessery?.contains(currentElement)) {
        closeQuickInfo();
      }
    }

    document.addEventListener('click', (event) => checkElement(event));

    return (
      document.removeEventListener('click', (event) => checkElement(event))
    )
  }, []);

  const { creationTime, descreption, parameters, quickData } = quickInfo;

  return (
    <div className="quick-stats-template">
      {
        creationTime > 0 &&
        <div className="quick-stats-template__wrapper">
          <div className="quick-stats-template__header">{t('created')}</div>
          <FormattedDate day="2-digit" year="numeric" month="2-digit" hour="numeric" minute="numeric" second="numeric" hour12={false} value={creationTime} />
        </div>
      }
      <div className="quick-stats-template__wrapper">
        {
          quickData.map((el) => {
            return (
              <div key={el.name} className="quick-stats-template__numbers">
                <span className="quick-stats-template__header">{el.name}:&nbsp;</span>

                <span className="quick-stats-template__info quick-stats-template__info-data">
                  <span>{roundUp(el.value)}</span>

                  {el.unit ? <span>{el.unit}</span> : null}
                </span>
              </div>
            );
          })
        }
      </div>
      {
        parameters.length ?
          <div className="quick-stats-template__wrapper">
            <div className="quick-stats-template__header">{t('parameters')}</div>
            <div className="quick-stats-template__info">
              {
                parameters.map((parameter, index) => {
                  if (parameters.length - 1 === index) {
                    return parameter
                  } else {
                    return parameter + ", "
                  }
                })
              }
            </div>
          </div> : null
      }
      {
        descreption ?
          <div className="quick-stats-template__wrapper">
            <div className="quick-stats-template__header">{t('description')}</div>
            <div className="quick-stats-template__info">{descreption}</div>
          </div> : null
      }
    </div>
  );
};

export default QuickStatsTemplate;
